export default __webpack_public_path__ + "static/media/draw.b1721b99.jpg";